module.exports = __webpack_public_path__ + "img/RegFees-OD-calendar.9d6584df.svg";